module.exports = __webpack_public_path__ + "static/bg_contact-shortw-a9f81991675185f51a186da96cd85a53.png";